/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface BranchPhoneTranslationRequestDto {
  id: string;
  name: string;
  language: BranchPhoneTranslationRequestDto.LanguageEnum;
}
// tslint:disable-next-line:no-namespace
export namespace BranchPhoneTranslationRequestDto {
  export type LanguageEnum = 'th' | 'en';
  export const LanguageEnum = {
      Th: 'th' as LanguageEnum,
      En: 'en' as LanguageEnum,
  };
}
